import { useState, useEffect, useContext } from "react";
import Checkbox from "../../../checkbox";
import Delete from "../../../icons/delete";
import styles from "./styles.module.css";
import { TypesValue } from "../../../contexts/types";

export default function SchemaItem({ schema, onChange, onDelete }) {
  const [_schema, setSchema] = useState(null);
  const types = useContext(TypesValue);

  useEffect(() => {
    setSchema(schema);
  }, [schema]);

  const handleNameChange = (value) => {
    const schema = { ..._schema };
    schema.name = value;
    setSchema(schema);
  };

  const handleTypeChange = (value) => {
    const schema = { ..._schema };
    schema.type = value;
    onChange(schema);
  };

  const handleListchange = (value) => {
    const schema = { ..._schema };
    schema.list = value;
    onChange(schema);
  };

  if (!_schema) {
    return null;
  }
  return (
    <div style={{ display: "flex", margin: "20px 0px 0px 0px" }}>
      <div>
        <div className={styles.inputTitle}>Name</div>
        <input
          value={_schema.name}
          onChange={(e) => handleNameChange(e.target.value)}
          style={{ width: 200, marginRight: 12 }}
          className={"input"}
          onBlur={() => onChange(_schema)}
        />{" "}
      </div>
      <div>
        <div className={styles.inputTitle}>Type</div>
        <select
          value={_schema.type}
          onChange={(e) => handleTypeChange(e.target.value)}
          style={{ width: 200, marginRight: 12 }}
          className={"dropdown"}
        >
          {types.map((t) => {
            return <option value={t.name}>{t.displayName}</option>;
          })}
        </select>
      </div>
      <div>
        <div className={styles.inputTitle}>List?</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            checked={schema.list}
            onChange={handleListchange}
            style={{ fontSize: 28, marginRight: 12, color: "#666" }}
          />
          <Delete onClick={onDelete} className={styles.deleteIcon} />
        </div>
      </div>
    </div>
  );
}
